import { getChunks, computeMd5, readAsArrayBuffer, getProgressInfoItem, compare, removeUrlParameters } from  '@/utils/huaweiUploadUiti'
import { agencyQnbarRequest, filterEmptyProperty, parseTime, getDownloadUrl } from '@/utils';
import { createPoolAndRunTask } from '@/utils/pool';
import axios from 'axios'
import * as wangsu from 'wcs-js-sdk'

const CancelToken = axios.CancelToken;
let cancel;

const controller = new AbortController()
// 网宿上传对象
let WSuploadObj = null

/**
 * 华为云上传
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} object_key    文件名
 * @param {object} file		     需要上传文件
 * @param {function} callback    上传结果回调
 * @param {function} ProgressBar  进度条回调
 * @param {string} base_module   原上传接口的module字段，兼容之前的接口
 */
export function huaweiUpload( platform, module, func, object_key, file, callback, ProgressBar, base_module = ''){
	// 根据参数发起请求获取上传链接
	let part_number = ''
	if(file.size > 52428800){
		let arr = getChunks(file,8388608)
		part_number = arr.length
	}else {
		part_number = ''
	}
	let content_type = file.type
	let parameter = {
		platform: platform,
		module: module,
		func: func,
		object_key: object_key,
		part_number: part_number,
		base_module: base_module,
		content_type: content_type
	}
	agencyQnbarRequest('HuaweiAndWsUpload',filterEmptyProperty(parameter))
	.then(
		res => {
			let upload_config = res.data.upload_config
			if(res.data.server_provider === 'WCS'){
				// 使用网宿上传
				WsUploadFile(platform, module, func, object_key, file, callback, ProgressBar, base_module,upload_config)
			}
			else if(res.data.server_provider === 'HW'){
				// 使用华为上传
				// 超过50mb进行分段上传
				if(file.size > 52428800){
					return sectionUploadfile(platform , module , func , object_key , file ,callback,ProgressBar,base_module,upload_config)
				}else {
					return uploadfile(platform , module , func , object_key , file , callback,ProgressBar,base_module,upload_config)
				}
			}
		}
	)

	// agencyQnbarRequest('')
}
/**
 * 分段上传
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} object_key		文件名
 * @param {File} file				文件
 * @param {Function} callback		上传回调函数
 * @param {Function} ProgressBar	进度条回调函数
 */
export function sectionUploadfile(platform , module , func , object_key , file, callback,ProgressBar,base_module,upload_config) {
	// 默认切片为8m字节
	let arr = getChunks(file,8388608)
	let parameter = {
		platform: platform,
		module: module,
		func: func,
		base_module: base_module,
		object_key: object_key,
		part_number: arr.length
	}
	let uploadfile = file
	let Host = upload_config[0].headers.Host
	let fileChunks = getChunks(uploadfile,8388608)
	console.log(upload_config)
	let urls = upload_config.map(item => {
		return {
			url: item.url,
			part_number : item.part_number
		}
	})
	uploadChunks(platform,module,func,Host,fileChunks,urls,uploadfile,object_key,callback,ProgressBar,base_module)
}
/**
 * 上传所有分段
 * @param {Object} Host
 * @param {Object} fileChunks
 * @param {Object} url
 * @param {Object} file
 */
function uploadChunks(platform,module,func,Host,fileChunks,urls,file,object_key,callback,ProgressBar,base_module) {
	let Host_2 = Host
	let upload_id = ''
	let fileChunks_2 = fileChunks
	let uploadArr = []
	let platform_2 = platform
	let base_module_2 = base_module
	let module_2 = module
	let func_2 = func
	// let temporaryUrl = ''
	const service = axios.create({
		headers: {
			"host": Host,
			'Content-Type': file.type
		}
	})
	let part_number = []
	let percent = 0
	let loaded = 0
	let size = file.size
	upload_id = getUrlParams(urls[0].url,'uploadId')
	for(let i=0;i<fileChunks_2.length;i++){
		let index = i + 1
			//已上传的块
		for(let j=0;j<urls.length;j++){
			let urlIndex = getUrlParams(urls[j].url,'partNumber')
			if(index == urlIndex){
				uploadArr[i] = new Promise(function(resolve, reject){
					resolve(
						service({
							method: 'put',
							// url: str_1 + '&partNumber=' + index + '&' + str_2 ,
							url: urls[j].url,
							data: fileChunks_2[i],
							signal: controller.signal,
							onUploadProgress: function(progressEvent){
								let progress = getProgressInfoItem(progressEvent.loaded,progressEvent.total)
								 // ProgressBar({total:progress})
							}
							// data: flie
						})
						.then(res => {
							let item = {
								PartNumber: index,
								ETag: res.headers.etag.replaceAll('"','')
							}
							loaded = loaded + fileChunks_2[i].size
							percent =  (loaded / size).toFixed(2)
							let value = {
								total : {
									loaded: loaded,
									percent: percent * 100,
									size: size
								}
							}
							ProgressBar(value)
							part_number.push(item)
							if(parseInt(percent - 0) === 1){
								mergeFile(platform,module,func,base_module,file,object_key,upload_id,part_number,callback)
							}
						})
					)
				})
			}
		}
	}
	let callback_3 = function(){
		// console.log('完成了回调aaa')
	}
	createPoolAndRunTask(uploadArr,8,callback_3)

	// Promise.all(uploadArr)
	// .then(
	// 	res => {
	// 		console.log('上传成功')
	// 		let arr = part_number.filter(item => item != null)
	// 		arr.sort(compare('PartNumber'))
	// 		let parameter = {
	// 			platform: platform_2,
	// 			module: module_2,
	// 			func: func_2,
 //        base_module: base_module_2,
	// 			object_key: file.name,
	// 			upload_id: upload_id,
	// 			parts: JSON.stringify(arr)
	// 		}
	// 		agencyQnbarRequest('HuaWeiMergeSection',filterEmptyProperty(parameter))
	// 		.then(
	// 			res => {
	// 				return callback(res)
	// 			}
	// 		)
	// 	}
	// )
	// .catch(
	// 	err => {
	// 		console.log('上传失败err=> ',err)
	// 		let parameter = {
	// 			platform: platform_2,
	// 			module: module_2,
	// 			func: func_2,
	// 		base_module: base_module,
	// 			object_key: file.name,
	// 			upload_id: upload_id,
	// 			// parts: JSON.stringify(arr)
	// 		}
	// 		agencyQnbarRequest('HuaWeiCancelUpload',filterEmptyProperty(parameter))
	// 		.then(
	// 			res => {
	// 				console.log('取消分段任务')
	// 			}
	// 		)
	// 	}
	// )
}

/** 获取url上的参数的值
 * @param {string} url
 * @param {string} arg
 */
function getUrlParams(url, key) {
	const Params = new URLSearchParams(url.split('?')[1])
	return Params.get(key)
}

/**
 * 修改链接中的url值
 * @param {Object} url		链接
 * @param {Object} arg		需要修改的参数名
 * @param {Object} arg_val  修改的值
 * @return {string}
 */
function changeURLArg(url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    } else {
        if (url.match('[\?]')) {
            return url + '&' + replaceText;
        } else {
            return url + '?' + replaceText;
        }
    }
}

/**
 * 单文件直传不分片
 * @param {Object} platform
 * @param {Object} module
 * @param {Object} func
 * @param {Object} object_key	文件名
 * @param {Object} file			文件
 * @param {Object} callback		进度回调
 */
export function uploadfile(platform , module , func , object_key , file , callback,callback_2,base_module,upload_config){
	// let host,url,promise
	let host = upload_config.headers.Host
	let url = upload_config.url
	console.log(upload_config.headers['Content-type'],'我在上')
	let contentType = upload_config.headers['Content-type']
	let filePath = upload_config.access_host + upload_config.file_path
	const service = axios.create({
		headers: {
			'host': host,
			'Content-Type': contentType
		},
		signal: controller.signal,
		onUploadProgress: function(progressEvent){
			 let progress = getProgressInfoItem(progressEvent.loaded,progressEvent.total)
			 callback_2({total:progress})
		}
	})
	service({
		method: 'put',
		url: url,
		// url: 'https://qnbar-test.obs.cn-east-3.myhuaweicloud.com:443/interface/img/1668667373922000.png?AccessKeyId=2ENXRG86DYW3VNYY1OCA&Expires=1668667673&Signature=DwRsJsb%2BYp4lQiJFFh3xMiHm8n8%3D',
		signal: controller.signal,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
		data: file
	})
	.then(
		res => {
			const data = {
				status: 200,
				fileType: file.type,
				fileSize: file.size,
				fileUrl: filePath
			}
			return callback(data)
		}
	)
	.catch(
		err => {
			StopUpload()
			const data = {
				status: 500,
				message: err
			}
			console.log(data)
			return callback(data)
		}
	)
}

// 停止上传
export function StopUpload(){
	// const controller = new AbortController()
	// let signal = controller.signal
		setTimeout(function(){
			controller.abort()
			cancel('cancelUpload')
		},100)
		if(WSuploadObj != null){
			setTimeout(function(){
				WSuploadObj.stop()
				WSuploadObj = null
			},100)
		}
}
/**
 * 发送请求合并块
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} base_module
 * @param {string} object_key
 * @param {string} upload_id
 * @param {Array} part_number 	所有已上传块的标识参数
 * @param {Function} callback
 */
function mergeFile (platform,module,func,base_module,file,object_key,upload_id,part_number,callback) {
	let arr = part_number.filter(item => item !== null)
	arr.sort(compare('PartNumber'))
	let parameter = {
		platform: platform,
		module: module,
		func: func,
		base_module: base_module,
		object_key: object_key,
		upload_id: upload_id,
		parts: JSON.stringify(arr),
	}

	agencyQnbarRequest('HuaWeiMergeSection',filterEmptyProperty(parameter))
	.then(
		res => {
			console.log(res)
			const data = {
				status: 200,
				fileType: file.type,
				fileSize: file.size,
				fileUrl: removeUrlParameters(res.data.access_host + res.data.url)
			}
      console.log(res.data.access_host + res.data.url)
			console.log(data)
			callback(data)
		}
	)
	.catch(
		err => {
			const data = {
				status: 500,
				message: err
			}
			callback(data)
			// 取消上传
			let parameter = {
				platform: platform,
				module: module,
				func: func,
				base_module: base_module,
				object_key: object_key,
				upload_id: upload_id,
			}
			agencyQnbarRequest('HuaWeiCancelUpload',filterEmptyProperty(parameter))
			.then(
				res => {
					console.log('取消成功')
				}
			)
			.catch(
				err => {
					console.log('取消失败')
				}
			)
		}
	)
}
/**
 * 网宿上传
 * @param {Object} platform
 * @param {Object} module
 * @param {Object} func
 * @param {Object} object_key
 * @param {Object} file
 * @param {Object} callback			结果回调函数
 * @param {Object} ProgressBar		进度回调函数
 * @param {Object} base_module
 */
function WsUploadFile (platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config) {
	const token = upload_config.token
	let prefix = 'https://'
	if(process.env.NODE_ENV !== 'production'){
	  prefix = 'http://'
	}
	console.log(upload_config)
	const uploadUrl = prefix + upload_config.request_url
	const extraConfig = {
		bucket: upload_config.bucket,
		file_name_rule: upload_config.file_name_rule,
		max_size_mb: upload_config.max_size_mb,
		retryCount: 0,
		key: upload_config.dir + object_key,
		concurrentRequestLimit: 6,			//  并发数 默认为6
		blockSize: 8,						//  文件块上传大小 默认为8M
	}
	const handlers =  {
	    Authorization : 'UpToken ' + upload_config.token,
	    uploadBatch : file.id
	}
	console.log(handlers)
	// 创建网宿上传对象
	WSuploadObj =  wangsu.wcsUpload(file, token, uploadUrl, extraConfig, handlers)
	console.log(WSuploadObj)
	// 网宿上传进度回调
	WSuploadObj.uploadProgress = function(progress){
		ProgressBar(progress)
	}
	// 网宿上传失败回调
	WSuploadObj.onError = function(err){
		const data = {
			status: 500,
			message: err.message
		}
	}
	// 网宿上传成功回调
	WSuploadObj.onComplete = function(res){
		const data = {
			status: 200,
			fileType: file.type,
			fileSize: file.size,
			fileUrl: upload_config.access_host + '/' + upload_config.dir + object_key
		}
		callback(data)
	}
	WSuploadObj.putFile()
}
// 上传对象
export class CommonUpload {
	constructor(platform, module, func, object_key, file, callback_2, base_module){
		this.platform = platform
		this.module = module
		this.func = func
		this.object_key = object_key
		this.file = file
		this.onComplete = function (data){
			console.log(data,'callback')
			callback_2(data)
		}
		this.uploadProgress  = function (data){
			console.log(data,'jindu')
		}
		this.base_module = base_module
	}
	// 上传文件
	putFile(){
		huaweiUpload(this.platform, this.module, this.func, this.object_key ,this.file, this.onComplete, this.uploadProgress, this.base_module)
	}
	// 停止上传
	stop(){
		StopUpload()
	}
}



// WEBPACK FOOTER //
// ./src/utils/HWupload.js